module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    attrs: {
      "id": "relatedproducts"
    }
  }, [_vm._v("Похожие товары")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-medium uk-grid-match uk-child-width-1-4@m uk-child-width-1-3@s",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.ShopItems), function(Product) {
    return _c('product', {
      key: Product.ShopItem.id,
      attrs: {
        "shop-item": Product.ShopItem,
        "image": Product.Asset,
        "shop-product": Product.ShopProduct,
        "shop-item-prices": _vm.ShopItemPrices[Product.ShopItem.id],
        "shop-item-properties": _vm.ShopItemProperties[Product.ShopItem.id]
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-304016c4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Product/RelatedProducts.vue
// module id = 105
// module chunks = 0